import MaritalStatus from "@/models/Shared/MaritalStatus";

export default (maritalStatus: MaritalStatus) => {
    let returnVal = "Unknown"
    switch (maritalStatus) {
        case MaritalStatus.Single:
            returnVal = "Single";
            break;
        case MaritalStatus.Married:
            returnVal = "Married";
            break;
        case MaritalStatus.Divorced:
            returnVal = "Divorced";
            break;
        case MaritalStatus.Separated:
            returnVal = "Separated";
            break;
        case MaritalStatus.Widowed:
            returnVal = "Widowed";
            break;
    }
    return returnVal;
} 